import { Button } from '@mui/material';
import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';

import { Img404 } from '../assets/img';

function NotFound() {
  return (
    <div className="w-full h-full flex items-center justify-center bg-osperb">
      <div className="flex items-center justify-enter">
        <div className="w-60">
          <img
            src={Img404}
            title="front‑end and back‑end development services working closely with our designers. As a UI/UX, web and app development company, we build native mobile apps for iOS and Android, web applications, ERP softwares and other solutions for all your business needs."
            alt="osperb innovation malappuram provide websites ERP'S applications and so on"
          />
        </div>
        <div className="w-30 flex items-start flex-col justify-center">
          <p className="text-2xl w-70">This is not the page you were looking for...</p>
          <Button
            component={'a'} // Use MUI's component prop
            href="/portfolio" // Route path
            className="custom_btn bg-white text-osperb-blue flex items-center gap-2"
            variant="contained" // MUI variant
            sx={{
              backgroundColor: 'white',
              color: '#0D47A1', // Replace with your "osperb-blue" hex
              textTransform: 'none', // keeps text as-is
            }}
          >
            Explore Our Portfolio
            <FiArrowUpRight size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
